import { allPass, curry, chain, compose, not, is, ifElse, isNil, reject, when, values } from "ramda"

const isNotFunction = (object) => compose(not, is(Function))(object)
const isNotPredicate = (predicate) => compose(not, predicate)

const createLeavesGetter = (predicate) => {
  return ifElse(allPass([isNotFunction, is(Object)]), compose(reject(isNil), chain(when(isNotPredicate(predicate), getLeavesWhich(predicate))), values), () => null)
}

const getLeavesWhich = curry((predicate, obj) => {
  return createLeavesGetter(predicate)(obj)
})

export default getLeavesWhich
